module.exports = __webpack_public_path__ + "static/heimat-04-ae8f95256a487fc03b1bd8008117edf0.jpg";